const state = () => ( {
  allData: [],
  totalData: 0,
  loading: false,
  cacheData: {},
  errors: [],
  flashErrorMessage: '',
  flashError: false,
  item: null,
  intervalExport: 0,
  exportId: null,
  ceountDataExport: 0,
  totalPage: 0,
  requestData: null,
  step: 1,
  data: {
    id: null,
    old_promo_type: '',
    promo_type: '',
    merchants: [],
    bulk_id: '',

    promo_name: '',
    qr_method_npm: false,
    qr_method_cpm: false,
    payment_type_on_us: false,
    payment_type_off_us: false,
    min_transaction: '',
    promo_period: [],
    promo_quota_per_merchant: '',
    promo_quota_per_customer: '',
    promo_quota_merchant_per_day: '',
    promo_quota_customer_per_day: '',
    jenis_promo: '',
    discount_type: '',
    percent: '',
    max_discount_amount: '',
    fix_amount: '',
    syarat_dan_ketentuan: '',
    bulk_upload_status: false,
    status: 1,
    disabled_form: false,
  },
  merchantList: [],
  finishStep: false,

  countData: 0,
  onUpload: false,

  allDataMerchantPromo: [],
  totalDataMerchantPromo: 0,
  totalPageMerchantPromo: 0,
});

export default state;
